var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-multiline is-mobile is-variable is-3-desktop is-2-mobile"},_vm._l((_vm.tracks),function(track){return _c('search-track-list-item',{key:track.id,attrs:{"track":track}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }